import React, { useEffect } from 'react';
import Delete from '../../../../../assets/icons/forms/trash_raw.svg';
import { DynamicComponent } from '../../Fields';
import styles from './OverlayField.module.scss';

const OverlayField = ({
  field,
  overlay,
  isPointerOutsideBuilder,
  fieldData,
  ...rest
}) => {
  const { type } = field;

  useEffect(() => {
    document.body.style.cursor = overlay ? 'grabbing' : 'default';

    return () => {
      document.body.style.cursor = 'auto';
    };
  }, [overlay]);

  return (
    <div className={styles.field}>
      <div
        className={`
        ${overlay ? styles.overlay : ''} 
        ${overlay && isPointerOutsideBuilder ? styles.remove : ''}`}
      >
        <DynamicComponent type={type} field={field} {...rest} />
      </div>
      {overlay && isPointerOutsideBuilder && (
        <div className={styles.remove_icon}>
          <Delete />
        </div>
      )}
    </div>
  );
};

export default OverlayField;
